import {createAction} from 'redux-act';

export const setLanguage = createAction('Set new language', (language) => ({language}));
export const languageSet = createAction('Language is loaded', (language, translations) => ({language, translations}));

